import Request from 'src/utils/request'

/**
 * 保存数据大屏
 * @returns
 */
export function saveScreenApi (data) {
  return Request({
    url: '/panel',
    method: 'post',
    data,
  })
}

/**
 * 回填数据大屏
 * @returns
 */
export function getScreenDataApi (id) {
  return Request({
    url: `/panel/${id}`,
    method: 'get',
  })
}

/**
 * 获取大屏下拉列表
 * @returns
 */
export function getScreenListApi () {
  return Request({
    url: 'panel/selector',
    method: 'get',
  })
}

/**
 *  保存组件数据
 * @returns
 */
export function saveComponentDataApi (data) {
  return Request({
    url: '/panel/chart_data',
    method: 'post',
    data,
  })
}

/**
 *  大屏删除
 * @returns
 */
export function deleteScreenApi (id) {
  return Request({
    url: `/panel/${id}`,
    method: 'delete',
  })
}

/**
 *  大屏名称重命名
 * @returns
 */
export function renameScreenApi (data) {
  return Request({
    url: '/panel/rename',
    method: 'post',
    data,
  })
}

/**
 *  自定义地址
 * @returns
 */
export function updatePanelSnApi (data) {
  return Request({
    url: '/panel/panelSn_update',
    method: 'post',
    data,
  })
}

/**
 *  复制大屏
 * @returns
 */
export function copyScreenApi (data) {
  return Request({
    url: '/panel/copy',
    method: 'post',
    data,
  })
}
/**
 *  获取数据指标下拉接口
 * @returns
 */
export function getDataIndicatorApi (data) {
  return Request({
    url: '/indicators/selector',
    method: 'get',
    unique: true,
    params: data,
  })
}
